import { render } from "./shopmaison-grid.vue?vue&type=template&id=042335b1&scoped=true"
import script from "./shopmaison-grid.vue?vue&type=script&lang=js"
export * from "./shopmaison-grid.vue?vue&type=script&lang=js"

import "./shopmaison-grid.vue?vue&type=style&index=0&id=042335b1&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042335b1"]])

export default __exports__